import { entries, notEqual, values } from "./javascript";
import formValidation from "./validations";

export const showFormErrors = (data, setData, ignore, errorName) => {
    let formErrors = {};
    entries(data).forEach(([key, value]) => {
        formErrors = {
            ...formErrors,
            ...formValidation(key, value, data, ignore, errorName),
        };
    });

    setData && setData({ ...data, formErrors });
    return !values(formErrors).some((v) => notEqual(v, ""));
};

export const showFormError = (data, setData, ignore = [], errorName) => {
  let formErrors = {};

  // Iterate over each field in the data object
  Object.entries(data).forEach(([key, value]) => {
    // Skip ignored fields
    if (ignore.includes(key)) return;

    // Validate the field and add errors to formErrors
    const error = formValidation(key, value, data, ignore, errorName);
    if (error[key]) {
      formErrors[key] = error[key];
    }
  });

  // Update the formErrors in the state if setData is provided
  if (setData) {
    setData((prevData) => ({
      ...prevData,
      formErrors,
    }));
  }

  // Return true if there are errors, false otherwise
  return Object.keys(formErrors).length > 0;
};